module.exports = __webpack_public_path__ + "d73279821b2772d3f113b40ed2065313.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/trophy-room-empty.png
// module id = 346
// module chunks = 0